module.exports = __webpack_public_path__ + "img/na.18e84bff.jpg";